import React, { useEffect } from 'react';
import Layout from '@/common/Layout';
import { message } from 'antd';
import UserView from './components/UserView';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import {
  get_by_profileView,
  send_request_list,
  short_list,
  download_profilebyid,
  respondActions,
  blockProfile
} from './redux/slice';

const index = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const navigate = useNavigate();
  const {
    profile_list,
    profileLoading,
    downloadLoading,
    downloadProfile,
    blockProfileLoading
  } = useSelector((state) => state.profileView);

  useEffect(() => {
    get_profile_view();
  }, []);

  const get_profile_view = () => {
    const payload = params.id;
    dispatch(get_by_profileView(payload));
  };

  // const handleProfileAction = async (data) => {
  //   console.log('Data from UserView:', data);

  //   if (data.action === 'send_request') {
  //     const payload = { request_to_profile_id: data.profile_id };
  //     dispatch(send_request_list(payload));
  //   } else if (data.action === 'short_profile') {
  //     const payload = { shortlisted_profile_id: data.profile_id };
  //     dispatch(short_list(payload));
  //   }
  // };

  const handleProfileAction = async (data) => {
    console.log('Data from UserView:', data);

    try {
      if (data.action === 'send_request') {
        const payload = { request_to_profile_id: data.profile_id };
        const result = await dispatch(send_request_list(payload));
        console.log('Send Request Response:', result);
      } else if (data.action === 'short_profile') {
        const payload = { shortlisted_profile_id: data.profile_id };
        const result = await dispatch(short_list(payload));
        console.log('Shortlist Response:', result);
      }

      // Fetch updated profile view after action completes
      const profileViewResult = await dispatch(get_profile_view());
      console.log('Updated Profile View:', profileViewResult);
    } catch (error) {
      console.error('Error handling profile action:', error);
    }
  };

  const handleDownload = async (user_id) => {
    try {
      const payload = user_id;
      // console.log('payload', payload);

      const response = await dispatch(download_profilebyid(payload));
      // const fileName = response?.payload?.fileName || 'profile.pdf';
      // console.log('File name:', fileName);
      // Check if response contains the buffer data
      if (response?.payload?.success && response?.payload?.data) {
        const bufferData = response.payload.data;

        // Convert buffer to Blob
        const blob = new Blob([new Uint8Array(bufferData)], {
          type: 'application/pdf'
        });

        // Create a URL for the Blob
        const url = window.URL.createObjectURL(blob);

        // Determine the file name, ensure it ends with ".pdf"
        let fileName = response?.payload?.fileName || 'profile';
        if (!fileName.toLowerCase().endsWith('.pdf')) {
          fileName += '.pdf';
        }

        // Open the Blob URL in a new tab
        // window.open(url, '_blank');

        // Create a temporary <a> element to trigger download
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName); // You can customize the filename here
        document.body.appendChild(link);
        link.click();

        // Cleanup
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);

        const successMsg =
          response?.payload?.message || 'Profile downloaded successfully!';
        message.success(successMsg);

        // Optional: Revoke the object URL after some time to free memory
        setTimeout(() => window.URL.revokeObjectURL(url), 10000);
      } else {
        console.error(
          'Failed to download the PDF. Invalid response:',
          response
        );
        const errorMsg =
          response?.payload?.message ||
          'Failed to download profile. Please try again.';
        message.error(errorMsg);
      }
    } catch (error) {
      console.error('Error downloading profile:', error);
      const errorMsg =
        error?.response?.data?.message ||
        'An error occurred while downloading the profile.';
      message.error(errorMsg);
    }
  };

  const handleRequestAction = async (status, profileId) => {
    // console.log('status', status);
    const payload = {
      requestor_profile_id: profileId,
      response_type: status
    };
    // console.log('payload', payload);
    // const result =
    await dispatch(respondActions(payload)).unwrap();
    // console.log('Shortlist Response:', result);
    await dispatch(get_profile_view()).unwrap();
  };

  const handleBlock = (profileId) => {
    // window.location.href = '/dashboard';
    // console.log('Block Profile', payload);
    let payload = { blocked_profile_id: profileId };
    dispatch(blockProfile(payload));
    // get_profile_view();
    navigate('/dashboard');
  };

  return (
    <Layout sider={true}>
      <UserView
        profile_list={profile_list}
        profileLoading={profileLoading}
        onSubmit={handleProfileAction}
        handleDownload={handleDownload}
        downloadProfile={downloadProfile}
        downloadLoading={downloadLoading}
        handleRequestAction={handleRequestAction}
        blockProfileLoading={blockProfileLoading}
        handleBlock={handleBlock}
      />
    </Layout>
  );
};

export default index;
